import { SearchIcon } from '@chakra-ui/icons'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react'
import algoliaSearch from 'algoliasearch/lite'
import * as React from 'react'
import { InstantSearch } from 'react-instantsearch-dom'
import SearchBox from './SearchBox'
import SearchHits from './SearchHits'

const searchClient = () => {
  if (!process.env.NEXT_PUBLIC_ALGOLIA_APP_ID)
    throw new Error('Missing Algolia App ID')
  if (!process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY)
    throw new Error('Missing Algolia Search API Key')

  return algoliaSearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY
  )
}

export default function Search() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button onClick={onOpen} color='blue.500' borderRadius='full'>
        <SearchIcon />
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent p={4}>
          <ModalHeader>Search for a project</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={4}>
            <InstantSearch
              searchClient={searchClient()}
              indexName='member_projects'>
              <SearchBox />
              <SearchHits />
            </InstantSearch>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
